// extracted by mini-css-extract-plugin
export default {"fixBottom":"index_fixBottom_LK2pe","whiteBg":"index_whiteBg_iLKGl","content_list":"index_content_list_7fv65","chip_item":"index_chip_item_Ts-fG"};